import api from '@api';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDomain } from '@useDomain';
import RacquetGamePublic from "./SportPages/Racquet/RacquetGamePublic";
import BasketballGamePublic from "./SportPages/Basketball/BasketballGamePublic";
import "./GamePublic.css";

function GamePublic() {
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statValues, setStatValues] = useState({});
  const [periodScores, setPeriodScores] = useState([]); // Add state for periodScores
  const { id } = useParams();
  const { domain, slug, organization } = useDomain();
  const theme = organization?.theme_mode || "light";


  useEffect(() => {
    const fetchGame = async () => {
      try {
        const res = await api.get(`/api/gamesv2/${id}`, {
          params: slug
            ? { slug, public_view: true }
            : { domain, public_view: true },
        });
        const {
          game,
          homeRoster,
          awayRoster,
          gamePeriods,
          periodScores,
          playerStats,
          allStats,
          racquetMatches,
        } = res.data;
        const homePlayers = homeRoster.map((r) => ({
          ...r.player,
          roster_id: r.id, // ✅ attach the roster ID from the join table
        }));
        const awayPlayers = awayRoster.map((r) => ({
          ...r.player,
          roster_id: r.id, // ✅ attach the roster ID from the join table
        }));
        setGame({
          ...game,
          stats: allStats,
          playerStats,
          gamePeriods,
          periodScores,
          racquetMatches: racquetMatches || [],
          score_team1: game.score_team1, // ✅ Make sure this exists!
          score_team2: game.score_team2, // ✅ Same here
          homeTeam: game.home_team?.team
            ? {
              ...game.home_team.team,
              players: homePlayers || [],
            }
            : null,

          awayTeam: game.away_team?.team
            ? {
              ...game.away_team.team,
              players: awayPlayers || [],
            }
            : null,
        });
        const values = {};
        playerStats.forEach((stat) => {
          values[`${stat.roster_id || stat.player_id}-${stat.stat_id}`] = stat.value;
        });
        setStatValues(values);
        setPeriodScores(periodScores);
      } catch (err) {
        console.error("Error fetching game:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchGame();
  }, [id, domain, slug]);

  if (loading) return null;
  if (!game) return <p className="not-found"></p>;

  const sportType = game.seasons_league?.league?.sportsv2?.type || "";
  const normalizedSport = sportType.toLowerCase();
  const isRacquetSport = ["tennis", "racquetball", "pickleball"].includes(
    normalizedSport
  );

  return (
    <div className={`game-public-page game-public-theme-${theme}`}>
      {isRacquetSport ? (
        <RacquetGamePublic
          game={game}
          theme={theme}
          slug={slug}
          statValues={statValues}
          periodScores={periodScores}
        />
      ) : (
        <BasketballGamePublic
          game={game}
          theme={theme}
          slug={slug}
          statValues={statValues}
          periodScores={periodScores}
        />
      )}
    </div>
  );
}

export default GamePublic;
